import { useState, useRef,useEffect } from "react";
import "../../styles/UserDashboard/EnergyUsageHistory.scss";
import { useSelector } from "react-redux";
import { fetchUserEnergyData } from "../../apis/EnergyEfficient/EfficientApi";
import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "../../apis/General/users";
import FormatTime from "../../utils/formatTime";

import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
  get,
} from "firebase/database";
import React from "react";

export default function EnergyUsageHistory() {
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);

  
  // Add selectedDate state
  const [selectedDate, setSelectedDate] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [firebaseData, setFirebaseDate]= useState(0)
  const [deviceId, setDeviceId] = useState()
  const dropdownRef = useRef(null);

  // Helper to get today and yesterday in YYYY-MM-DD
  const getDateString = (offset = 0) => {
    const d = new Date();
    d.setDate(d.getDate() - offset);
    return d.toISOString().slice(0, 10);
  };
  const today = getDateString(0);
  const yesterday = getDateString(1);

  const getDeviceId = async()=>{
        const  response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log(response)
    setDeviceId(response?.data?.message?.registeredDevices[0].deviceId)

  }

  // console.log(deviceId)
 const db = getDatabase();
   const getFireBaseData = async () => {
   const newRef = ref(db, "dev-energy-efficiency-table");
  const snapshot = await get(newRef);

  if (snapshot.exists()) {
    const data = Object.values(snapshot.val());
    return data;
         } else {
           console.log(`No data found`);
         }
       
     };
     const { data, isLoading, error } = useQuery({
  queryKey: ["energy-sharing-data"],
  queryFn: getFireBaseData,
  enabled: !!deviceId, // optional gating by auth
});
// console.log(data)
  
    useEffect(() => {
      // getFireBaseData();
      getDeviceId();
    }, []);
    // console.log(deviceId)/
    
  // Use react-query for withdrawal history
  // const { data, isLoading, error } = useQuery({
  //   queryKey: ["fetch-energy-consumed", deviceId],
  //   queryFn: () => fetchUserEnergyData(deviceId),
  //   enabled: !!deviceId,
  // });

  // if(data){
  //   console.log(data)
  // }
  // if(error){
  //   console.log(error)
  // }

  // Extract withdrawal items from API response
  const EnergyUsageHistory = data || [];
  
  // Sort data by created_at in descending order (newest first)
  const sortedEnergyHistory = EnergyUsageHistory.sort((a, b) => {
    if (!a?.created_at || !b?.created_at) return 0;
    return new Date(b.created_at) - new Date(a.created_at);
  });
  
console.log("EnergyUsageHistory", sortedEnergyHistory);

  // Filter items by selectedDate if set
  const filteredItems = selectedDate === "last7"
    ? sortedEnergyHistory.filter(item => {
        if (!item?.created_at) return false;
        const itemDate = new Date(item.created_at);
        const now = new Date();
        const diff = (now - itemDate) / (1000 * 60 * 60 * 24);
        return diff <= 7 && diff >= 0;
      })
    : selectedDate
      ? sortedEnergyHistory.filter(item => {
          if (!item?.created_at) return false;
          const itemDate = new Date(item.created_at);
          const selectedDateObj = new Date(selectedDate);
          return itemDate.toDateString() === selectedDateObj.toDateString();
        })
      : sortedEnergyHistory;
    
  // Date label for button
  const getDateLabel = (val) => {
    if (!val) return "Today";
    if (val === yesterday) return "Yesterday";
    if (val === "last7") return "Last 7 days";
    return val;
  };

  // Handle click outside to close dropdown
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);
    
  return (
    <div className="energy-withdrawal-histories">
     
      <div className="energy-withdrawal-history__inners">

        <div className="energy-withdrawal-history__inner__table" id="table">
          <div className="energy-withdrawal-history__inner__table__title-group">
            <div>
            {/* <div className="energy-withdrawal-history__inner__table__title-group__title">
              Recent activities
            </div> */}
            <div className="">
              <div><span className="text-[20px] mt-20 font-semibold">Energy usage history</span></div>
            </div>
            </div>
            {/* Date picker for daily selection */}
            <div className="energy-withdrawal-history__inner__table__title-group__date-picker" style={{ display: 'flex', gap: 8 }}>
              <div style={{ position: 'relative' }} ref={dropdownRef}>
                <button
                  type="button"
                  onClick={() => setDropdownOpen((v) => !v)}
                  className="px-4 py-2 min-w-[100px] bg-white border border-[#E5E5E5] rounded-lg flex items-center justify-between text-[#282828] text-[15px] font-medium shadow-sm"
                >
                  <span>{getDateLabel(selectedDate)}</span>
                  <svg className="ml-2" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M7 10L12 15L17 10" stroke="#898989" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                {dropdownOpen && (
                  <div className="absolute top-full left-0 z-10 bg-white border border-[#E5E5E5] rounded-lg shadow-lg min-w-[120px] mt-1">
                    <div
                      className={`px-4 py-2 cursor-pointer ${selectedDate === '' ? 'bg-[#f3f3f3]' : ''}`}
                      onClick={() => { setSelectedDate(''); setDropdownOpen(false); }}
                    >Today</div>
                    <div
                      className={`px-4 py-2 cursor-pointer ${selectedDate === yesterday ? 'bg-[#f3f3f3]' : ''}`}
                      onClick={() => { setSelectedDate(yesterday); setDropdownOpen(false); }}
                    >Yesterday</div>
                    <div
                      className={`px-4 py-2 cursor-pointer ${selectedDate === 'last7' ? 'bg-[#f3f3f3]' : ''}`}
                      onClick={() => { setSelectedDate('last7'); setDropdownOpen(false); }}
                    >Last 7 days</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className=" flex gap-96 bg-[#2C9963] p-8 text-white text[14px">
            <div className=" ml-10">
              Time (AM/PM)
            </div>
            <div className="">
              Energy usage (kWh)
            </div>
            <div className="ml-10">
            Source
            </div>
          
          </div>

          {/* Withdrawal history table body */}
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
          ) : error ? (
            <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
              Error loading withdrawal history</div>
          ) : filteredItems.length === 0 ? (
            <>
            <div  style={{ justifyItems: "center", padding: "5px", color: "#999", marginTop:"100px" }}>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.1758 31.9911L32.0038 29.1641L44.0228 41.1831L41.1948 44.0101L29.1758 31.9911Z" fill="#616161"/>
<path d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z" fill="#616161"/>
<path d="M32.4492 35.3397L35.2762 32.5117L43.9722 41.2077L41.1442 44.0357L32.4492 35.3397Z" fill="#37474F"/>
<path d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z" fill="#00AED9"/>
<path d="M26.8984 14.2C25.1984 12.2 22.6984 11 19.9984 11C17.2984 11 14.7984 12.2 13.0984 14.2C12.6984 14.6 12.7984 15.3 13.1984 15.6C13.5984 16 14.2984 15.9 14.5984 15.5C15.9984 13.9 17.8984 13 19.9984 13C22.0984 13 23.9984 13.9 25.3984 15.5C25.5984 15.7 25.8984 15.9 26.1984 15.9C26.3984 15.9 26.6984 15.8 26.7984 15.7C27.1984 15.3 27.1984 14.6 26.8984 14.2Z" fill="#BBDEFB"/>
</svg>

            </div>
            <div style={{ textAlign: "center", padding: "5px", color: "#999",  marginTop:"5px"}} className="text-3xl">
             Nothing to see here
              
              </div>
            </>

          ) : (
            filteredItems.map((item, idx) => (
              <div key={idx}  className="ml-10 grid grid-cols-3 gap-4 px-6 py-8 border-b text-[14px] text-gray-700 hover:bg-gray-50">
                <div>{item?.created_at ? FormatTime(item.created_at).toLocaleString() : "--"}</div>
                <div>{item?.energyConsumptionKw ? `${item.energyConsumptionKw} kWh` : "-"}</div>
                <div className="ml-[2px]">{item?.source || "No source provided"}</div>

              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
